import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "p-fluid p-component p-formgrid p-grid p-input-filled" }
const _hoisted_2 = { class: "p-field p-col-6" }
const _hoisted_3 = {
  key: 0,
  class: "p-error"
}
const _hoisted_4 = { class: "p-field p-col-6" }
const _hoisted_5 = {
  key: 0,
  class: "p-error"
}
const _hoisted_6 = { class: "p-field p-col-6" }
const _hoisted_7 = { class: "p-field p-col-6" }
const _hoisted_8 = { class: "p-fluid p-formgrid p-grid p-jc-end" }
const _hoisted_9 = { class: "p-field p-col-3" }
const _hoisted_10 = { class: "p-field p-col-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Message = _resolveComponent("Message")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Password = _resolveComponent("Password")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Message, {
      severity: "warn",
      closable: false
    }, {
      default: _withCtx(() => [
        _createElementVNode("h3", null, _toDisplayString(_ctx.$t('Squeeze.System.Warning')), 1),
        _createTextVNode(" " + _toDisplayString(_ctx.$t('Squeeze.System.MicrosoftAuthenticationWarningMessage')), 1)
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("label", null, _toDisplayString(_ctx.$t('Squeeze.System.ClientId')) + " *", 1),
        _createVNode(_component_InputText, {
          modelValue: _ctx.systemMicrosoftAuthentication.clientId,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.systemMicrosoftAuthentication.clientId) = $event)),
          onChange: _ctx.update,
          disabled: _ctx.loading
        }, null, 8, ["modelValue", "onChange", "disabled"]),
        ((_ctx.v$.clientId.$invalid && _ctx.showErrorMessage))
          ? (_openBlock(), _createElementBlock("small", _hoisted_3, _toDisplayString(_ctx.$t('Forms.Val.MissingRequired', { field: _ctx.$t('Squeeze.System.ClientId')})), 1))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("label", null, _toDisplayString(_ctx.$t('Squeeze.System.Password')) + " *", 1),
        _createVNode(_component_Password, {
          modelValue: _ctx.systemMicrosoftAuthentication.clientSecret.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.systemMicrosoftAuthentication.clientSecret.value) = $event)),
          placeholder: _ctx.systemMicrosoftAuthentication.clientSecret.isSet ? '*****' : '',
          feedback: false,
          onChange: _ctx.update,
          disabled: _ctx.loading
        }, null, 8, ["modelValue", "placeholder", "onChange", "disabled"]),
        ((_ctx.v$.clientSecret.value.$invalid && _ctx.showErrorMessage))
          ? (_openBlock(), _createElementBlock("small", _hoisted_5, _toDisplayString(_ctx.$t('Forms.Val.MissingRequired', { field: _ctx.$t('Squeeze.System.Password')})), 1))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("label", null, _toDisplayString(_ctx.$t('Squeeze.System.GroupIdUsers')), 1),
        _createVNode(_component_InputText, {
          modelValue: _ctx.systemMicrosoftAuthentication.groupIdUsers,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.systemMicrosoftAuthentication.groupIdUsers) = $event)),
          onChange: _ctx.update,
          disabled: _ctx.loading
        }, null, 8, ["modelValue", "onChange", "disabled"])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("label", null, _toDisplayString(_ctx.$t('Squeeze.System.GroupIdAdmins')), 1),
        _createVNode(_component_InputText, {
          modelValue: _ctx.systemMicrosoftAuthentication.groupIdAdmins,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.systemMicrosoftAuthentication.groupIdAdmins) = $event)),
          onChange: _ctx.update,
          disabled: _ctx.loading
        }, null, 8, ["modelValue", "onChange", "disabled"])
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _createVNode(_component_Button, {
          label: _ctx.$t('Squeeze.System.ResetCredentials'),
          type: "button",
          icon: "mdi mdi-delete-outline",
          class: "p-button p-button-danger",
          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.saveMicrosoftAuthenticationCredentials($event, true)))
        }, null, 8, ["label"])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createVNode(_component_Button, {
          label: _ctx.$t('Squeeze.General.Save'),
          type: "button",
          icon: "mdi mdi-content-save-outline",
          class: "p-button",
          onClick: _ctx.saveMicrosoftAuthenticationCredentials,
          loading: _ctx.loading
        }, null, 8, ["label", "onClick", "loading"])
      ])
    ])
  ], 64))
}